export default "__VITE_ASSET__BsFyEVGe__"